import ArkoseLabsFrame from 'components/ArkoseLabs/ArkoseLabsFrame/ArkoseLabsFrame';

export default ArkoseLabsFrame;
